import { FC } from 'react'
import { PaymentStatusProps } from './payment-status.types'
import { usePaymentStatus } from './use-payment-status'

export const PaymentStatus: FC<PaymentStatusProps> = ({ checkoutSession }) => {
  usePaymentStatus(checkoutSession)

  return null
}
